export enum OrderChangeLogActionTypes {
  Created = 'Created',
  Modified = 'Modified',
  LineItemAdded = 'LineItemAdded',
  LineItemRemoved = 'LineItemRemoved',
  DocumentUploaded = 'DocumentUploaded',
  DocumentRemoved = 'DocumentRemoved',
  Corrected = 'Corrected'
}
